import Vue from 'vue';
import VueRouter from 'vue-router';
import home from '../views/Home.vue';
import aboutus from '../views/aboutus.vue';
import contactus from '../views/contactUs.vue'
Vue.use(VueRouter)
const routes = [
  // {
  //   path: '/',
  //   redirect: '/home',
  //   // component: home,
  // },
  {
    path: '/',
    component: home,
    // children: [
    //   {
    //     path: '/about',
    //     component: aboutus
    //   },
    //   {
    //     path: '/contact',
    //     component: contactus
    //   },
    // ]
  },
  {
    path: '/about',
    component: aboutus
  },
  {
    path: '/contact',
    component: contactus
  },
]

const router = new VueRouter({
  mode: 'history', // 去掉url中的#
  base: "/home/",
  routes
})

export default router
